// import route from 'ziggy-js';

export default {
    methods: {
        url(path) {
            var url = '';
            const appUrl = this.appUrl;

            if (appUrl) {
                url += appUrl
            }

            return url + '/' + path;
        }

        // route: (name, params, absolute, config = Ziggy) => route(name, params, absolute, config)
    }
};
